import { Inline } from '@bedrock-layout/primitives'
import { FullWidthTextSection, Heading, Paragraph, WysiwygBlock } from '@okam/brand-ui'
import { theme } from 'twin.macro'
import ContactForm from '@/components/forms/ContactForm'
import { MainLayout } from '@/components/layout'
import { useFragment } from 'gql'
import type { CafepageQuery, MainMenuFragment, SiteOptionsQuery } from 'gql/graphql'
import { allMembersFragment } from 'query/fragments'

export interface TCafePage {
  pageProps: CafepageQuery & SiteOptionsQuery
}
const CafeVirtuelPage = (props: TCafePage) => {
  const { pageProps } = props
  const { page, siteOptions, mainMenu } = pageProps
  const title = pageProps.page?.title
  const allMembers = useFragment(allMembersFragment, pageProps.members)
  const content = pageProps.page?.content

  return (
    <MainLayout
      siteOptionsProps={siteOptions}
      seo={page?.seo}
      allMembers={allMembers}
      menuItems={mainMenu as MainMenuFragment}
      variant="white"
      translatedUri={page?.translatedUri}
    >
      <FullWidthTextSection
        colorTheme={theme('colors.tertiary.6')}
        minHeight="400px"
        patternPosition="left"
        xAlign="center"
        yAlign="bottom"
      >
        {title && (
          <Heading as="h2" variant="h2" tw="text-white font-bold">
            {title}
          </Heading>
        )}
        {content && (
          <Paragraph as="span" variant="p" tw="text-tertiary-2">
            <WysiwygBlock content={content} />
          </Paragraph>
        )}
      </FullWidthTextSection>

      <Inline
        justify="center"
        tw="flex flex-col h-full items-center pt-24 pb-10 lg:pt-28 lg:pb-16 xl:pt-32 px-6 mx-auto md:px-12 lg:px-14 w-full max-w-[1920px]"
      >
        <ContactForm />
      </Inline>
    </MainLayout>
  )
}

export default CafeVirtuelPage
